export function inArray(needle, haystack) {
  const length = haystack.length;
  for (let i = 0; i < length; i++) {
    if (haystack[i] === needle) {
      return true;
    }
  }
  return false;
}

export function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.MaxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

export function isDateInputSupported() {
  const dateInput = document.createElement("input");
  const dateValue = "a";
  dateInput.setAttribute("type", "date");
  dateInput.setAttribute("value", dateValue);
  return dateInput.value !== dateValue;
}

export function replaceStateCodeWithName(stateCode) {
  const states = {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
    AS: "American Samoa",
    AE: "Armed Forces (Canada, Europe, Africa, or Middle East)",
    AA: "Armed Forces Americas",
    AP: "Armed Forces Pacific",
    FM: "Federated States of Micronesia",
    GU: "Guam",
    MH: "Marshall Islands",
    MP: "Northern Mariana Islands",
    PW: "Palau",
    PR: "Puerto Rico",
    US: "United States",
    VI: "Virgin Islands"
  };

  return states[stateCode];
}

export default {
  inArray,
  isTouchDevice,
  isDateInputSupported,
  replaceStateCodeWithName
};
